import { privPutRequest } from "../vidCloud/priv";

const SignerDataService = {};

SignerDataService.sendSignerData = (signerGuid, body) => {
  return privPutRequest(`/signers/${signerGuid}/signerdata`, body);
}

export default SignerDataService;